import type { SoftLoginProviderAdapter } from '../../domain/interfaces/SoftLoginProviderAdapter';

export class SoftLoginService {
  constructor(private readonly providers: SoftLoginProviderAdapter[]) {}

  start(onSuccess: () => void): void {
    if (typeof window === 'undefined') {
      return;
    }

    for (const provider of this.providers) {
      if (provider.isEnabled()) {
        provider.start(onSuccess);
      }
    }
  }
}

export function createSoftLoginService(providers: SoftLoginProviderAdapter[]): SoftLoginService {
  return new SoftLoginService(providers);
}
